import React from 'react';
import PropTypes from 'prop-types';
import { GetFormRow, GetBrText } from '../utilities';

// ���͒l�S���Z�b�g
const inputdel = () => {
    var elements = document.inputForm.elements;
    for (var i = 0; i < elements.length; i++) {
        var e = elements[i];
        if (e.type == 'text' || e.type == 'textarea') {
            e.value = '';
        } else
        if (e.tagName.toLowerCase() == 'select') {
            e.selectedIndex = 0;
        }
    }
};

const InputForm = (
  {
    inputDisplay,
    form,
    handleSubmit,
    clearForm,
    requesting,
    errors,
    isError,
    form_settings
  }
) => {
  if (!inputDisplay) {
    return null;
  }
  return (
    <form action="" name="inputForm" onSubmit={e => handleSubmit(e)} onReset={() => clearForm()}>
      <p className="contact-message">{GetBrText(form_settings.form_text.contact_message)}</p>
      {isError ? <p className="error">{form_settings.form_text.confirm_error}</p> : null}
      <table className="table-forms">
        {form_settings.fields && form_settings.fields.map(field => GetFormRow(field, form, errors, form_settings))}
      </table>
      <p className="text-center">{form_settings.form_text.confirm_usage}</p>
      {requesting ? null : (
        <div className="button-forms">
          <input type="button" className="btn-fanuc btn-fanuc--gray" value={form_settings.form_text.clear} onClick={() => { inputdel() }} />
          <input type="submit" className="btn-fanuc btn-fanuc--yellow" value={form_settings.form_text.confirm} />
        </div>
      )}
    </form>
  );
};

InputForm.propTypes = {
  inputDisplay: PropTypes.bool.isRequired,
  form: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  clearForm: PropTypes.func.isRequired,
  requesting: PropTypes.bool.isRequired,
  errors: PropTypes.object.isRequired,
  isError: PropTypes.bool.isRequired,
  form_settings: PropTypes.object.isRequired,
};

export default InputForm;
